'use client'

import { useEffect, useState } from 'react'

interface ScrollProgressBarProps {
  useRainbow?: boolean;
  color?: string;
  height?: number;
}

export default function ScrollProgressBar({ 
  useRainbow = true,
  color = '#F5CC5C', 
  height = 3 
}: ScrollProgressBarProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(scrollPercent);
    };

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    return () => window.removeEventListener('scroll', updateProgress);
  }, []);

  const rainbowGradient = 'linear-gradient(90deg, #E40303 0%, #FF8C00 20%, #FFED00 40%, #008026 60%, #24408E 80%, #732982 100%)';

  return (
    <div 
      className="fixed top-0 left-0 w-full z-[60]"
      style={{ height }}
    >
      <div
        className="h-full transition-all duration-100 ease-out"
        style={{
          width: `${progress}%`,
          background: useRainbow ? rainbowGradient : color,
          boxShadow: progress > 0 ? '0 0 12px rgba(255, 255, 255, 0.4)' : 'none'
        }}
      />
    </div>
  );
}
